import { setFilterSheetsOpen, updateFilterMap } from "./slice";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import _ from "lodash";

/**
 * Hook for handling filterSheets redux state
 */
export const useFilterSheets = () => {
    const dispatch = useAppDispatch();
    const selector = useAppSelector(state => state.filterSheets);

    return {
        isFilterSheetsOpen: selector.isOpen,
        filterMap: selector.filtersMap,
        setFilterSheetsOpen: payload => dispatch(setFilterSheetsOpen(payload)),
        resetFilters: () => dispatch(updateFilterMap(new Map())),
        handleFilterMapUpdate: payload => useOnChangeFilter(payload, selector.filtersMap, dispatch),
    };
};

/**
 * Hook for handling change on table filters
 */
export const useOnChangeFilter = (action, filtersMap, dispatch) => {
    switch (action.type) {
        case "UPDATE": {
            const state: Map<string, any> = new Map(filtersMap);
            const { filterKey, value } = action;

            if (value?.length <= 0 || (_.isArray(value) && value?.every(e => e?.length <= 0))) {
                state.delete(filterKey);
            } else {
                state.set(filterKey, { value });
            }

            return () => {
                dispatch(updateFilterMap(state));
            };
        }

        case "REMOVE": {
            const state: Map<string, any> = new Map(filtersMap);
            const { filterKey } = action;
            state.has(filterKey) && state.delete(filterKey);

            return () => {
                dispatch(updateFilterMap(state));
            };
        }

        case "RESET": {
            return () => {
                dispatch(updateFilterMap(new Map()));
            };
        }
    }
};
